import React from 'react';
import {getAssetPath} from "../../../../../utils/get-asset-path.js";

const Icon = ({value}) => {
    if (!value) return (<></>)

    return (
        <div className={"w-full h-full flex items-center justify-center"}>
            <img className={"w-[25px]"} src={getAssetPath(`/img/video-cameras/${value}.svg`)} alt=""/>
        </div>
    );
}

export default Icon;